import { createSelector } from 'reselect';
import { Map } from 'immutable';

const selectFundingSearchOffers = (state) =>
  state.getIn(['fundingSearch', 'fundingSearchMatchOffers'], Map());
const selectFundingSearchOffer = (state) =>
  state.getIn(['fundingSearch', 'fundingSearchMatchOffer'], Map());

const makeSelectFundingSearchOffersById = () =>
  createSelector(selectFundingSearchOffers, (state) => state.get('byId', Map()));

const makeSelectFundingSearchOffersByMatchId = () =>
  createSelector(selectFundingSearchOffers, (state) => state.get('groupByFundingMatchId', Map()));

const makeSelectFundingSearchOffersLoading = () =>
  createSelector(selectFundingSearchOffers, (state) => state.getIn(['network', 'loading']));

const makeSelectFundingSearchOfferById = () =>
  createSelector(selectFundingSearchOffer, (state) =>
    state.getIn(['ids', state.getIn(['network', 'id'])]),
  );

const makeSelectFundingSearchOfferMatchLoading = () =>
  createSelector(
    selectFundingSearchOffer,
    (state) => state.getIn(['network', 'loading']) || state.getIn(['match', 'network', 'loading']),
  );

export {
  makeSelectFundingSearchOffersById,
  makeSelectFundingSearchOffersLoading,
  makeSelectFundingSearchOffersByMatchId,
  makeSelectFundingSearchOfferById,
  makeSelectFundingSearchOfferMatchLoading,
  selectFundingSearchOffer,
  selectFundingSearchOffers,
};
